const KEY = 'domain-path-filter-pref-link-script'

export type DomainPathFilterSelection = {
    // Map of domainId -> top-level path prefixes (e.g. ["/blog/", "/shop/"])
    // Empty array = all paths for that domain selected
    // Empty outer object = no filter active (show all)
    domains: { [domainId: number]: string[] }
}

export const EMPTY_SELECTION: DomainPathFilterSelection = { domains: {} }

export function isFilterActive(selection: DomainPathFilterSelection): boolean {
    return Object.keys(selection.domains).length > 0
}

export function saveFilterPref(selection: DomainPathFilterSelection): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(selection))
    } catch {
        // ignore
    }
}

export function loadFilterPref(): DomainPathFilterSelection {
    try {
        const raw = localStorage.getItem(KEY)
        if (!raw) return EMPTY_SELECTION
        const parsed = JSON.parse(raw)
        if (parsed && typeof parsed === 'object' && parsed.domains) return parsed
    } catch {
        // ignore
    }
    return EMPTY_SELECTION
}
